var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 24.6387L29.3613 28.25V30.0137H0.638672V28.25L4.25 24.6387V15.7363C4.25 12.9368 4.94987 10.5013 6.34961 8.42969C7.80534 6.35807 9.79297 5.01432 12.3125 4.39844V3.13867C12.3125 2.41081 12.5645 1.79492 13.0684 1.29102C13.5723 0.73112 14.2161 0.451172 15 0.451172C15.7839 0.451172 16.4277 0.73112 16.9316 1.29102C17.4355 1.79492 17.6875 2.41081 17.6875 3.13867V4.39844C20.207 5.01432 22.1667 6.35807 23.5664 8.42969C25.0221 10.5013 25.75 12.9368 25.75 15.7363V24.6387ZM15 35.3887C13.9922 35.3887 13.1243 35.0527 12.3965 34.3809C11.7246 33.709 11.3887 32.8691 11.3887 31.8613H18.6113C18.6113 32.8132 18.2474 33.653 17.5195 34.3809C16.7917 35.0527 15.9518 35.3887 15 35.3887Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.f578eca2c7f77dcebf6b169973ce055f.svg";
export { ForwardRef as ReactComponent };